// @flow

import TabPanel from './TabPanel.ui';

export default TabPanel;
